module.exports = __webpack_public_path__ + "img/Techies.e379d314.png";